import { render, staticRenderFns } from "./UpdateShipmentModal.vue?vue&type=template&id=1ab79a2b&scoped=true&"
import script from "./UpdateShipmentModal.vue?vue&type=script&lang=js&"
export * from "./UpdateShipmentModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateShipmentModal.vue?vue&type=style&index=0&id=1ab79a2b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab79a2b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab79a2b')) {
      api.createRecord('1ab79a2b', component.options)
    } else {
      api.reload('1ab79a2b', component.options)
    }
    module.hot.accept("./UpdateShipmentModal.vue?vue&type=template&id=1ab79a2b&scoped=true&", function () {
      api.rerender('1ab79a2b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Shipments/components/UpdateShipmentModal.vue"
export default component.exports